import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postQuoteUploadDocument } from "../../store/apapUploadAttachments/actions";
export var PostUploadDocuments = function (trigger, id, fileName, pdfFile, documentProfileId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseUploadDocuments: state.UploadAttach.responseUploadDocuments,
        errorUploadDocuments: state.UploadAttach.errorUploadDocuments,
        loadingUploadDocuments: state.UploadAttach.loadingUploadDocuments,
    }); }), responseUploadDocuments = _a.responseUploadDocuments, errorUploadDocuments = _a.errorUploadDocuments, loadingUploadDocuments = _a.loadingUploadDocuments;
    useEffect(function () {
        if (trigger) {
            dispatch(postQuoteUploadDocument({
                id: id,
                fileName: fileName,
                pdfFile: pdfFile,
                documentProfileId: documentProfileId,
            }));
        }
    }, [trigger, id, fileName, pdfFile, documentProfileId]);
    return {
        responseUploadDocuments: responseUploadDocuments,
        errorUploadDocuments: errorUploadDocuments,
        loadingUploadDocuments: loadingUploadDocuments,
    };
};
